/*
 * A typescript & react boilerplate with api call example
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {ModuleFE_RoutingV2, TS_Route} from '@nu-art/thunderstorm-frontend/index';
import * as Routes from './route-keys.js';
import {Page_AdvisorDowntime, Page_Bootstrap, Page_Sandbox, Page_SmartOnFhir} from '@app/advisor-frontend';
import {Const_LaunchSmart} from '@app/fhir-shared';
import {Page_Demo_NEW} from '@app/advisor-frontend/ui/pages/NEW_Page_Demo/index';
import {Page_AdvisorSwitcher, Page_DeployIntegration} from '@app/advisor-v5-frontend/ui/index';
import {config} from '../config.js';
import {ComponentValidateSessionV2} from '@app/advisor-v5-frontend/ui/components/ComponentValidateSessionV2';


export type RouteKey =
	typeof Routes.Route_Home |
	typeof Routes.Route_Demo |
	typeof Routes.Route_AdvisorDowntime |
	typeof Routes.Route_Advisor |
	typeof Routes.Route_BroadcastTarget |
	typeof Routes.Route_BroadcastHub |
	typeof Routes.Route_LaunchSmartOnFhir |
	typeof Routes.Route_LaunchDeployOnFhir |
	typeof Routes.RouteKey_AdvisorWrapper;


const Route_AdvisorWrapper: TS_Route = {
	key: Routes.RouteKey_AdvisorWrapper,
	path: 'advisor-wrapper',
	index: ['LOCAL', 'USABILITY 2024'].includes(config.label),
	Component: Page_Demo_NEW
};

export const AdvisorRoutes: TS_Route = {
	key: Routes.Route_Home,
	path: '/',
	index: !['USABILITY 2023', 'LOCAL'].includes(config.label),
	fallback: true,
	children: [
		Route_AdvisorWrapper,
		{
			key: Routes.Route_Advisor,
			path: 'advisor',
			Component: ComponentValidateSessionV2,
			children: [
				{
					key: 'physician',
					path: 'physician',
					fallback: true,
					Component: Page_AdvisorSwitcher,
				},
				{
					key: 'nurse', path: 'nurse', fallback: true, Component: Page_AdvisorSwitcher,
				},
			]
		},
		{
			key: Routes.Route_Demo,
			index: true,
			path: 'demo',
			Component: () => ModuleFE_RoutingV2.redirect(Route_AdvisorWrapper),
		},
		{key: Routes.Route_LaunchSmartOnFhir, path: Const_LaunchSmart, Component: Page_SmartOnFhir},
		{key: Routes.Route_LaunchAvatar, path: 'launch-avatar', Component: Page_Bootstrap},
		{key: Routes.Route_LaunchBootstrap, path: 'launch-bootstrap', Component: Page_Bootstrap},
		{key: Routes.Route_AdvisorDowntime, path: 'advisor-downtime', Component: Page_AdvisorDowntime},
		{key: Routes.Route_LaunchDeployOnFhir, path: 'launch-deploy', Component: Page_DeployIntegration},
		Page_Sandbox.Route,
	]
};